module.exports = ".image-container img {\n\tborder: 1px solid #CCC;\n\tpadding: 10px;\n}"